import { motion } from "framer-motion";
import CountUp from "@/components/CountUp";

const ease = [0.16, 1, 0.3, 1];

const stats = [
  {
    end: 68,
    suffix: "%",
    headline: "veraltete Websites",
    desc: "Lokale Betriebe verlieren täglich Kunden durch veraltete oder fehlende Online-Präsenz.",
  },
  {
    end: 40,
    suffix: "%",
    headline: "keine Website",
    desc: "Fast die Hälfte aller Handwerksbetriebe ist online gar nicht auffindbar — und weiß es oft nicht.",
  },
  {
    end: 24,
    prefix: "< ",
    suffix: "h",
    headline: "bis zum ersten Kunden",
    desc: "Mit der richtigen Methode kannst du deinen ersten zahlenden Kunden in unter 24 Stunden gewinnen.",
  },
];

export default function ProblemSection() {
  return (
    <section
      className="py-32 md:py-40 px-6 bg-[#0A0A0A]"
      data-testid="problem-section"
    >
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease }}
          className="text-center mb-24"
        >
          <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.3em] uppercase">
            Das Problem
          </span>
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#F5F5F7] mt-4 leading-tight tracking-tight"
            style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "-0.02em" }}
          >
            Die Lücke, die du schließt
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white/8">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease, delay: i * 0.1 }}
              className="px-8 py-10 md:py-0 text-center"
              data-testid={`problem-stat-${i}`}
            >
              <div
                className="text-5xl sm:text-6xl font-black text-[#C9A84C] mb-3 leading-none"
                style={{ textShadow: "0 0 30px rgba(201,168,76,0.2)" }}
              >
                <CountUp end={s.end} prefix={s.prefix} suffix={s.suffix} />
              </div>
              <p className="text-[#F5F5F7] font-semibold text-lg mb-3">{s.headline}</p>
              <p className="text-[#86868b] text-sm leading-relaxed max-w-xs mx-auto">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
